export default {
	modalVisibility: 0,
	HIDE_MODALS: 0,
	SHOWING_PHASE_CHANGE_MODAL: 1,
	SHOWING_PAUSED_MODAL: 2,
	oneHour: 60 * 60 * 1000,
	phaseName: undefined,
	// Must be set to something other than `undefined` or a real date so that `delegateEndDateChange` will definitely be triggered
	endDate: "willBeChanged",
	phaseNumber: undefined,
	offsetMsToServer: 0,
	navbarString: undefined,
	dashboardStrings: undefined,
	countdownInterval: undefined,
	handleEndDateChangeFunction: undefined,
	requirePhaseFeedbackAfterPhaseChange: false,
	durationNamesAndSeconds: { day: 86400, hour: 3600, minute: 60 },
	oneSecond: 1000,

	init(options) {
		// pp.log("GAME STATE init -- options", options);
		this.options = options;

		if (this.countdownInterval === undefined) {
			// @ts-expect-error
			this.countdownInterval = setInterval(this.countdownLoop, this.oneSecond);
		}

		this.unobserveChange("phaseNumber", this.handlePhaseNumberChange);
		this.unobserveChange("endDate", this.delegateEndDateChange);
		this.unobserveChange("modalVisibility", this.handleModalVisibilityChange);

		this.observeChange("phaseNumber", this.handlePhaseNumberChange);
		this.observeChange("endDate", this.delegateEndDateChange);
		this.observeChange("modalVisibility", this.handleModalVisibilityChange);
	},

	handlePhaseNumberChange(oldPhaseNumber, newPhaseNumber) {
		if (oldPhaseNumber != newPhaseNumber) {
			pp.log(
				"GAME STATE handle Phase number change -- old, new",
				oldPhaseNumber,
				newPhaseNumber,
			);
		}

		// Page has just been loaded
		if (oldPhaseNumber === undefined) {
			if (newPhaseNumber == 0) {
				// No current Phase and User is not a moderator
				// @ts-expect-error
				this.handleEndDateChangeFunction = this.handlePageLoadAfterGameEnded;
			} else if (newPhaseNumber == -1) {
				// The Game has ended but the current Actor is a ghost
				// @ts-expect-error
				this.handleEndDateChangeFunction = (oldPhaseEnd, newPhaseEnd) => {
					pp.log(
						"GAME STATE page just loaded, Game ended but Actor ghost",
						oldPhaseEnd,
						newPhaseEnd,
					);
					this.modalVisibility = this.SHOWING_PAUSED_MODAL;
				};
			} else {
				// There is a running Phase
				// @ts-expect-error
				this.handleEndDateChangeFunction = (oldPhaseEnd, newPhaseEnd) => {
					pp.log(
						"GAME STATE page just loaded, current Phase present",
						oldPhaseEnd,
						newPhaseEnd,
						this.requirePhaseFeedbackAfterPhaseChange,
					);
					if (newPhaseEnd === undefined) {
						this.modalVisibility = this.SHOWING_PAUSED_MODAL;
					} else if (this.requirePhaseFeedbackAfterPhaseChange) {
						// This will have been set in `fetchLatestGameState`
						this.modalVisibility = this.SHOWING_PHASE_CHANGE_MODAL;
					}
				};
			}
		}

		// There was a current Phase
		else if (newPhaseNumber != -1) {
			if (newPhaseNumber == 0) {
				// @ts-expect-error
				this.handleEndDateChangeFunction =
					oldPhaseNumber == 0
						? this.handlePageLoadAfterGameEnded
						: this.handleGameEnd;
			} else if (
				oldPhaseNumber + 1 == newPhaseNumber &&
				// @ts-expect-error
				this.endDate < new Date()
			) {
				// The previous Phase has ended
				// @ts-expect-error
				this.handleEndDateChangeFunction = this.handleScheduledNewPhaseStart;
			} else if (oldPhaseNumber != newPhaseNumber) {
				// The current Phase has changed
				// @ts-expect-error
				this.handleEndDateChangeFunction = this.handleDynamicNewPhaseStart;
			} else {
				// We're staying in the same Phase
				// @ts-expect-error
				this.handleEndDateChangeFunction = this.handleEndDateChangeInSamePhase;
			}
		}

		// Only for mods
		if (newPhaseNumber > 0) {
			$(".j-countdown-phase-number").text(newPhaseNumber);
		} else {
			$(".j-countdown-phase-number").text("-");
		}
	},

	handleScheduledNewPhaseStart(oldPhaseEnd, newPhaseEnd) {
		pp.log(
			"GAME STATE scheduled Phase has started by",
			oldPhaseEnd,
			newPhaseEnd,
		);
		if (
			$("#phase-change-modal").length &&
			$("#phase-change-modal").hasClass("modal")
		) {
			this.modalVisibility = this.SHOWING_PHASE_CHANGE_MODAL;
		} else {
			this.autoJumpToNewPhase();
		}
	},

	handleDynamicNewPhaseStart(oldPhaseEnd, newPhaseEnd) {
		pp.log("GAME STATE Phase changed dynamically", oldPhaseEnd, newPhaseEnd);
		this.autoJumpToNewPhase();
	},

	handlePageLoadAfterGameEnded(oldPhaseEnd, newPhaseEnd) {
		pp.log(
			"GAME STATE page just loaded, no current Phase",
			oldPhaseEnd,
			newPhaseEnd,
		);
		if ($("body").hasClass("moderator-view")) {
			return;
		}
		const localizedMsg = `<h3>${I18n.t("modal_overlays.phase_change.game_ended_title")}</h3><p>${I18n.t("modal_overlays.phase_change.you_will_be_logged_off_after_24h")}</p>`;
		pp.notifications.display("notice", localizedMsg, { dismissable: true });
		const oneDayAfterLastPhaseEnd = new Date(
			newPhaseEnd.getTime() + this.offsetMsToServer + 24 * pp.gameState.oneHour,
		);
		setTimeout(() => {
			this.initLogoutTimeoutWithFunction(() => {
				$.ajax({
					url: `/actors/${pp.currentActorId}/logout?source=oneDayGracetimeAfterGameEndOver`,
					dataType: "script",
				});
			});
			// @ts-expect-error
		}, oneDayAfterLastPhaseEnd - new Date());
	},

	handleEndDateChangeInSamePhase(oldPhaseEnd, newPhaseEnd) {
		pp.log("GAME STATE Phase NOT changed", oldPhaseEnd, newPhaseEnd);
		if (
			oldPhaseEnd !== undefined &&
			newPhaseEnd !== undefined &&
			oldPhaseEnd.getTime() === newPhaseEnd.getTime()
		) {
			return;
		}
		if (oldPhaseEnd === undefined && newPhaseEnd !== undefined) {
			// The Phase has just been unpaused
			this.modalVisibility = this.HIDE_MODALS;
		} else if (newPhaseEnd === undefined) {
			this.modalVisibility = this.SHOWING_PAUSED_MODAL;
		} else {
			this.modalVisibility = this.HIDE_MODALS;
			if (oldPhaseEnd !== undefined) {
				// Only show this if the Phase hadn't been paused
				this.composeCountdownStrings(newPhaseEnd); // Compose anew so that the `dashboardStrings` can be shown in the notice
				const noticeString = I18n.t(
					"moderators_area.phase_manager.flash.phase_duration_changed",
					{
						phase_name: this.phaseName,
						// @ts-expect-error
						remaining_str: this.dashboardStrings.join(" "),
					},
				);
				pp.notifications.display("notice", noticeString, {
					dismissable: true,
					category: "phase_duration_changed",
				});
			}
		}
	},

	delegateEndDateChange(oldval, newval) {
		// pp.log("GAME STATE delegateEndDateChange -- old, new", oldval, newval);

		// @ts-expect-error
		this.handleEndDateChangeFunction(oldval, newval);
		// Call this again so that what should be done next time the endDate changes gets re-evaluated
		this.handlePhaseNumberChange(this.phaseNumber, this.phaseNumber);
	},

	countdownLoop() {
		const module = pp.gameState;
		// Calculate what the time is on the Rails server, and us that as the basis for the countdown
		const now = new Date(new Date().getTime() + module.offsetMsToServer);
		// pp.log("GAME STATE into countdownLoop -- endDate, now", module.endDate, now);

		if (module.endDate === undefined) {
			return;
		}
		// @ts-expect-error
		if (now < module.endDate) {
			const $countdownProgressDial = $(".j-countdown-progress-dial--active");
			if ($countdownProgressDial.length) {
				const phaseLength = parseInt(
					$countdownProgressDial.data("phase-length"),
				);
				// @ts-expect-error
				const remaining = module.endDate - now;
				const permillRemaining = (remaining / phaseLength) * 1000;
				$countdownProgressDial.val(permillRemaining);
				$countdownProgressDial.trigger("change");
			}

			module.composeCountdownStrings(module.endDate);

			// Only overwrite if the string has actually changed
			if (
				$(".j-countdown").length &&
				$(".j-countdown").html() !== module.navbarString
			) {
				// @ts-expect-error
				$(".j-countdown").html(module.navbarString);
				if ($(".Sticky-button--phase-countdown__progress").length) {
					// Only in moderator's area
					$(".Sticky-button--phase-countdown__progress").css({
						width: `${pp.phaseManager.calculateProgressPerc(module.phaseNumber)}%`,
					});
				}
			}
			if ($(".j-dashboard-countdown").length) {
				$(".j-dashboard-countdown").html(
					// @ts-expect-error
					module.dashboardStrings.join(" ") + ".",
				);
			}
		} else if (
			// @ts-expect-error
			module.phaseNumber > 0 &&
			module.modalVisibility == module.HIDE_MODALS
		) {
			// Means that there is an actual Phase that has just ended
			module.populateNewPhaseModal(0); // Make the modal only show "Next Phase is starting now" and the loading ring
			module.modalVisibility = module.SHOWING_PHASE_CHANGE_MODAL;
		}
	},

	composeCountdownStrings(endDate) {
		// pp.log("into", endDate, now);

		const now = new Date(new Date().getTime() + this.offsetMsToServer);
		let days = 0;
		let hours = 0;
		let minutes = 0;
		let seconds = 0;
		let showMinutes = true;
		let showSeconds = true;
		let navbarString = "";
		const dashboardStrings = [];

		// days
		while (now.getTime() + 24 * this.oneHour < endDate) {
			days++;
			now.setTime(now.getTime() + 24 * this.oneHour);
		}

		// hours
		// @ts-expect-error
		hours = Math.floor((endDate - now) / this.oneHour);
		now.setTime(now.getTime() + hours * this.oneHour);

		// minutes
		// @ts-expect-error
		minutes = Math.floor((endDate - now) / (60 * 1000));
		now.setTime(now.getTime() + minutes * 60 * 1000);

		// seconds
		// @ts-expect-error
		seconds = Math.floor((endDate - now) / 1000);

		if (days >= 1) {
			dashboardStrings.push(days);
			dashboardStrings.push(
				I18n.t("datetime.names_for_countdown.day", { count: days }),
			);
			navbarString += `<span class='timer-bold'>${days}<small>d</small></span>`;
			showMinutes = false;
			showSeconds = false;
		}

		if (hours > 0) {
			dashboardStrings.push(hours);
			dashboardStrings.push(
				I18n.t("datetime.names_for_countdown.hour", { count: hours }),
			);
			navbarString += `<span class="${showMinutes ? "timer-bold" : "timer-thin"}">${hours}<small>h</small></span>`;
			showSeconds = false;
		} else {
			showMinutes = true;
		}

		if (showMinutes) {
			dashboardStrings.push(minutes);
			dashboardStrings.push(
				I18n.t("datetime.names_for_countdown.minute", { count: minutes }),
			);
			navbarString += `<span class='${showSeconds ? "timer-bold" : "timer-thin"}'>${minutes}<small>m</small></span>`;
			if (minutes == 0) {
				showSeconds = true;
			}
		}

		if (showSeconds) {
			dashboardStrings.push(seconds);
			dashboardStrings.push(
				I18n.t("datetime.names_for_countdown.second", { count: seconds }),
			);
			if (seconds < 10) {
				// @ts-expect-error
				seconds = "0" + seconds;
			}
			navbarString += `<span class='timer-thin${showMinutes && hours > 0 ? " timer-thin--last" : ""}'>${seconds}<small>s</small></span>`;
		}

		// color red
		const markRed =
			($("body").hasClass("gameTheme-unionslabor") &&
				minutes == 0 &&
				seconds < 39) ||
			(!$("body").hasClass("gameTheme-unionslabor") &&
				days == 0 &&
				hours == 0 &&
				minutes < 5);
		$(".j-countdown")[markRed ? "addClass" : "removeClass"]("red");

		// @ts-expect-error
		this.navbarString = navbarString;
		// @ts-expect-error
		this.dashboardStrings = dashboardStrings;
	},

	handleModalVisibilityChange(oldval, newval) {
		pp.log("GAME STATE into handleModalVisibilityChange", oldval, newval);
		if (oldval == newval) {
			return; // Nothing to do
		}
		$("div.modal.in").modal("hide"); // Hide all other modals that might be displayed right now

		const $phaseChangeModal = $("#phase-change-modal");
		if (newval == this.SHOWING_PHASE_CHANGE_MODAL) {
			$(".j-countdown").html(
				'<span class="timer-bold">0<small>m</small></span><span class="timer-thin">00<small>s</small></span>',
			);
			$(".j-dashboard-countdown").html(
				`0 ${I18n.t("datetime.names_for_countdown.minute", { count: 0 })} 0 ${I18n.t("datetime.names_for_countdown.second", { count: 0 })}`,
			);

			if ($phaseChangeModal.hasClass("modal")) {
				setTimeout(() => {
					$phaseChangeModal.modal("show");
				}, 100); // Wait for other modals to have faded out if necessary
			} else {
				// Unionslabor, expect a `.fullscreen-modal`
				$phaseChangeModal.removeClass("hidden");
			}
			this.initPhaseChangeAutoFetchInterval();
		} else if (newval == this.SHOWING_PAUSED_MODAL) {
			if (![undefined, -1].includes(this.phaseNumber)) {
				$(".j-countdown").html("<span class='timer-bold'>⏸</span>");
				$(".j-dashboard-countdown").html("");
				if (!$("body").hasClass("moderator-view")) {
					$("#phase-paused-modal").modal("show");
				}
			} else {
				$(".j-countdown").html("<span class='timer-bold'>-</span>");
			}
		}
	},

	handleGameEnd(oldPhaseEnd, newPhaseEnd) {
		pp.log("GAME STATE into handleGameEnd", oldPhaseEnd, newPhaseEnd);
		const $phaseChangeModal = $("#phase-change-modal");
		if ($phaseChangeModal.length && $phaseChangeModal.hasClass("modal")) {
			$phaseChangeModal
				.find(".modal-body h2")
				.text(I18n.t("modal_overlays.phase_change.game_ended_title"));
			$phaseChangeModal
				.find(".modal-body h4.j-phase-sub-headline")
				.text(
					I18n.t("modal_overlays.phase_change.thank_you_for_participating"),
				);
			this.modalVisibility = this.SHOWING_PHASE_CHANGE_MODAL;
			if ($("body").hasClass("moderator-view")) {
				return;
			}

			$("#phase-change-modal .phase-change-modal--phase-info").addClass(
				"hidden",
			);
			$phaseChangeModal.removeClass("phase-change-modal--modal-loading");
		} else {
			this.autoJumpToNewPhase();
		}
	},

	fetchLatestGameState(optionsHash = {}) {
		const options = $.extend(
			{},
			{
				pullActivities: false,
				pullDescriptionAndTasks: true,
				calledAfterPageLoad: false,
			},
			optionsHash,
		);
		pp.log("GAME STATE fetchLatestGameState -- options", options);
		if (pp.currentActorId === undefined) {
			pp.log("- returning");
			return;
		}

		const succcessCallback = ({
			phase_id,
			phase_number,
			phase_end,
			phase_name,
			server_time,
			description,
			duration,
			task_titles,
			completed_phase_tasks_size,
			phase_info_has_been_read,
		}) => {
			const module = pp.gameState;
			let newPhaseEnd;
			if (phase_end !== null) {
				newPhaseEnd = new Date(phase_end * 1000);
			}

			module.phaseName = phase_name;
			// @ts-expect-error
			module.offsetMsToServer = new Date(server_time * 1000) - new Date();
			module.phaseId = phase_id;
			module.phaseNumber = phase_number;
			module.phaseDescription = description;
			module.phaseDuration = duration;

			// @ts-expect-error
			module.requirePhaseFeedbackAfterPhaseChange =
				module.populateNewPhaseModal(
					phase_id || 0,
					newPhaseEnd,
					description,
					task_titles,
					options.calledAfterPageLoad,
					phase_info_has_been_read,
				);
			// @ts-expect-error
			module.endDate = newPhaseEnd;

			if (task_titles !== undefined) {
				$(".j-completed-tasks").text(completed_phase_tasks_size);
				$(".j-total-tasks").text(task_titles.length);
			}

			module.clearPhaseChangeAutoFetchInterval(); // Does nothing if no interval present

			if (!options.pullActivities) {
				return;
			}
			// If the Game has not ended *or* the Game has ended, but less than 24h ago
			if (
				phase_id != 0 ||
				// @ts-expect-error
				(newPhaseEnd !== undefined && newPhaseEnd > oneDayAgo)
			) {
				pp.activities.pullActivities();
			}
		};

		$.ajax({
			type: "GET",
			url: "/activities/rerender_latest_game_state",
			data: { pull_description_and_tasks: options.pullDescriptionAndTasks },
			dataType: "json",
			success: succcessCallback,
			error({ status }) {
				if (status == 403) {
					// forbidden
					pp.gameState.initSessionExpiredMessage();
				}
			},
		});
	},

	populateNewPhaseModal(
		phaseId,
		newPhaseEnd,
		description,
		taskTitles = [],
		calledAfterPageLoad = false,
		phaseInfoHasBeenRead = true,
	) {
		$("input:focus, textarea:focus").blur(); // don't let users write anything anymore (and make sure that the mobile onscreen keyboard collapses so that the modal is visible)
		// pp.log("GAME STATE into populateNewPhaseModal - phaseId, description, taskTitles", phaseId, description, taskTitles, phaseInfoHasBeenRead);

		const $phaseChangeModal = $("#phase-change-modal");
		if (!$phaseChangeModal.hasClass("modal")) {
			// Unionslabor
			return false;
		}

		// Not `!phaseInfoHasBeenRead`, it might also be `undefined`
		// Don't show the modal if also the intro modal is being shown
		const requirePhaseFeedbackAfterPhaseChange =
			!$("body").hasClass("moderator-view") &&
			calledAfterPageLoad &&
			phaseInfoHasBeenRead == false &&
			!$("#intro-modal").hasClass("in");
		const $phaseChangeModalContinueButton = requirePhaseFeedbackAfterPhaseChange
			? $phaseChangeModal.find(".modal-footer a.button[data-dismiss]")
			: $phaseChangeModal.find(".modal-footer a.button[href]");

		if (
			!$phaseChangeModalContinueButton.length &&
			!$("body").hasClass("moderator-view")
		) {
			return; // Nothing to show
		}
		// else

		$phaseChangeModalContinueButton
			.removeClass("hidden")
			.removeClass("disabled")
			.removeAttr("disabled");
		$phaseChangeModal
			.find(".modal-footer a.button")
			.not($phaseChangeModalContinueButton)
			.addClass("hidden");
		$phaseChangeModal.find(".j-description-and-tasks").html(""); // Purge previous content

		if (phaseId != 0) {
			// A current Phase is present
			this.composeCountdownStrings(newPhaseEnd); // Call this to save the string in `pp.gameState.dashboardStrings`

			$phaseChangeModal.removeClass("phase-change-modal--modal-loading");
			$phaseChangeModal
				.find(".modal-body h2")
				.text(
					I18n.t(
						`modal_overlays.phase_change.${requirePhaseFeedbackAfterPhaseChange ? "new_phase_has_started" : "next_phase_starting_now"}`,
					),
				);
			$phaseChangeModal
				.find(".modal-body h4.j-phase-sub-headline")
				// @ts-expect-error
				.text(this.phaseName);
			$phaseChangeModal
				.find(".j-phase-end-date")
				// @ts-expect-error
				.html(moment(newPhaseEnd).format("Y-MM-DD, HH:mm"));
			$phaseChangeModal.find(".j-description-and-tasks").append(description);
			$phaseChangeModal
				.find(".phase-change-modal--phase-info")
				.removeClass("hidden");
			$phaseChangeModalContinueButton.attr("data-tracked-data-value", phaseId);
			$phaseChangeModalContinueButton.one("click", () => {
				this.modalVisibility = this.HIDE_MODALS;
			});
			if (taskTitles.length) {
				$phaseChangeModal.find(".j-description-and-tasks").append(`\
					<h4>${I18n.t("global.your_tasks")}</h4>\
					<ul>${taskTitles.map((taskTitle) => `<li>${taskTitle}</li>`).join("")}</ul>\
				`);
			}
		} else {
			$phaseChangeModal.addClass("phase-change-modal--modal-loading");
			$phaseChangeModal.find(".modal-body h4.j-phase-sub-headline").text("");
		}

		return requirePhaseFeedbackAfterPhaseChange;
	},

	initLogoutTimeoutWithFunction(functionString) {
		pp.log("GAME STATE into initLogoutTimeoutWithFunction");
		$("#notice-modal").find("p").html(I18n.t("backend.logout_actors_message"));
		$("#notice-modal").modal("show");
		setTimeout(functionString, 5000);
	},

	initSessionExpiredMessage() {
		$("#shell-modal div.modal-header > h3").html(
			I18n.t("private_pub.session_expired_header"),
		);
		$("#shell-modal div.modal-header").removeClass("hidden");
		$("#shell-modal div.modal-body").html(
			`${I18n.t("private_pub.session_expired_copy")}<p><a href='/' class='button'>${I18n.t("global.actions.to_homepage")}</a></p>`,
		);
		$("#shell-modal").modal("show");
	},

	autoJumpToNewPhase() {
		pp.log("GAME STATE into autoJumpToNewPhase");
		if (
			pp.currentActorId === undefined ||
			$("body").hasClass("moderator-view")
		) {
			pp.log("- returning because mod or not logged in");
			pp.stickyButtons.phaseState.init();
			return;
		}
		this.modalVisibility = this.SHOWING_PHASE_CHANGE_MODAL;
		const $phaseChangeModal = $("#phase-change-modal");
		let remainingSeconds = $phaseChangeModal.hasClass("modal") ? 7 : 1;

		$phaseChangeModal.find(".j-countdown-number").text(remainingSeconds); // Set initial number
		$phaseChangeModal.find(".j-closing-soon").removeClass("hidden");
		const phaseChangeUnscheduledInterval = setInterval(() => {
			remainingSeconds--;
			$phaseChangeModal.find(".j-countdown-number").text(remainingSeconds);
			if (remainingSeconds != 0) {
				return;
			}
			pp.pageChangeConfirm.removeListeners(); // In case there was some unsent text in an input field
			clearInterval(phaseChangeUnscheduledInterval);
			this.modalVisibility = this.HIDE_MODALS;

			try {
				Turbolinks.visit("/");
			} catch (exception) {
				// Turbolinks does not track its `currentState` for some reason when navigating via `Turbolinks.visit('/')`,
				// so after two auto-jumped Phases it throws `TypeError: currentState is null` in `cacheCurrentPage`.
				pp.log("Exception:", exception);
				window.location.reload();
			}
		}, 1000);

		// Abort timeout if user dismisses Phase change modal themselves
		$phaseChangeModal
			.find("a.button[data-tracked-data-value]")
			.one("click", () => {
				clearInterval(phaseChangeUnscheduledInterval);
			});
	},

	durationToParts(duration) {
		let delta = duration;
		const parts = [];
		Object.keys(this.durationNamesAndSeconds).forEach((unitName) => {
			const secondsInUnit = this.durationNamesAndSeconds[unitName];
			const countInUnit = Math.floor(
				delta / this.durationNamesAndSeconds[unitName],
			);
			parts.push(countInUnit);
			delta -= countInUnit * secondsInUnit;
		});
		return parts;
	},

	initPhaseChangeAutoFetchInterval() {
		// pp.log("into initPhaseChangeAutoFetchInterval -- present interval", this.phaseChangeAutoFetchInterval)
		this.clearPhaseChangeAutoFetchInterval(); // Does nothing if no interval present
		this.phaseChangeAutoFetchInterval = setInterval(() => {
			// Will call `clearPhaseChangeAutoFetchInterval` if the request goes through
			this.fetchLatestGameState();
		}, 20 * 1000); // 20 seconds -- approximate the longst (tolerable) duration it takes to start a new Phase (in Games with many Properties)
	},

	clearPhaseChangeAutoFetchInterval() {
		// pp.log("into clearPhaseChangeAutoFetchInterval -- present interval", this, this.phaseChangeAutoFetchInterval)
		if (this.phaseChangeAutoFetchInterval) {
			clearInterval(this.phaseChangeAutoFetchInterval);
			this.phaseChangeAutoFetchInterval = undefined;
		}
	},
};
